module.exports = __webpack_public_path__ + "y.no2.c3fb7d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/y.no2.jpg
// module id = SjWk
// module chunks = 0